var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitHaarlemLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "186.96mm",
    height: "53.56mm",
    viewBox: "0 0 529.96 151.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b18132;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HAARLEM_STER_LB",
    "data-name": "HAARLEM STER LB"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.42,66.06H56.31V29h14.3v94.79H56.31V79.51H15.42v44.26H1.12V29h14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.71,83.38l29.35,40.39h-17.5L247.49,85h-2.58v38.8H230.6V29h16.76Q266.15,29,274.5,36q9.21,7.86,9.21,20.75a27,27,0,0,1-5.77,17.32A25.75,25.75,0,0,1,262.71,83.38Zm-17.8-10.87h4.54q20.32,0,20.32-15.53,0-14.55-19.77-14.55h-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.87,29v81.35h27.87v13.44H305.57V29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.78,42.43h-38V65.2h36.89V78.65H375.78v31.68h38v13.44H361.47V29h52.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.84,123.77l20-101.91,32.53,73.67L512,21.86,530,123.77H515.29l-9.15-57.21-28.05,61.57L450.83,66.49l-10.19,57.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.13 0.91 124.77 22.75 150.03 22.74 134.97 43.79 143.13 69 119.19 60.17 98.97 75.75 99.23 49.25 78.57 33.67 102.68 26.12 110.13 0.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.17 40.41 99.23 49.25 78.57 33.67 116.17 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.17 40.41 119.19 60.17 98.97 75.75 116.17 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.97 43.79 143.13 69 116.17 40.41 134.97 43.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "124.77 22.75 150.03 22.74 116.17 40.41 124.77 22.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.13 0.91 116.17 40.41 102.68 26.12 110.13 0.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.35 0.9 198.8 26.11 222.92 33.66 202.26 49.24 202.53 75.74 182.31 60.16 158.36 69 166.52 43.79 151.45 22.74 176.72 22.74 191.35 0.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.32 40.41 166.52 43.79 151.45 22.74 185.32 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.32 40.41 182.31 60.16 158.36 69 185.32 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.26 49.24 202.53 75.74 185.32 40.41 202.26 49.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "198.8 26.11 222.92 33.66 185.32 40.41 198.8 26.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.35 0.9 185.32 40.41 176.72 22.74 191.35 0.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.36 151.83 176.72 129.99 151.45 129.99 166.52 108.95 158.35 83.74 182.3 92.57 202.52 76.99 202.25 103.49 222.92 119.07 198.8 126.61 191.36 151.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.32 112.32 202.25 103.49 222.92 119.07 185.32 112.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.32 112.32 182.3 92.57 202.52 76.99 185.32 112.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.52 108.95 158.35 83.74 185.32 112.32 166.52 108.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "176.72 129.99 151.45 129.99 185.32 112.32 176.72 129.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.36 151.83 185.32 112.32 198.8 126.61 191.36 151.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.13 151.83 102.68 126.62 78.57 119.08 99.23 103.49 98.96 76.99 119.18 92.57 143.13 83.74 134.96 108.95 150.03 129.99 124.76 129.99 110.13 151.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.16 112.33 134.96 108.95 150.03 129.99 116.16 112.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.16 112.33 119.18 92.57 143.13 83.74 116.16 112.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.23 103.49 98.96 76.99 116.16 112.33 99.23 103.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.68 126.62 78.57 119.08 116.16 112.33 102.68 126.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.13 151.83 116.16 112.33 124.76 129.99 110.13 151.83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitHaarlemLogo);
export default __webpack_public_path__ + "static/media/visit-haarlem-logo.3aa7bdec8596180f421584a396a8cfaf.svg";
export { ForwardRef as ReactComponent };